export class ConsumerAvailableUrlPartInfo {
    public culture?: string;
    public url?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): ConsumerAvailableUrlPartInfo {
        const urlPartInfo: ConsumerAvailableUrlPartInfo = new ConsumerAvailableUrlPartInfo();

        urlPartInfo.culture = this.culture;
        urlPartInfo.url = this.url;

        return urlPartInfo;
    }
}

export class ConsumerAvailable {
    public organizationId: number = 0;
    public consumerId: number = 0;
    public isCanonical: boolean = false;
    public urlParts: ConsumerAvailableUrlPartInfo[] = [];

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            urlParts: json.urlParts ? json.urlParts.map((urlPart: any) => new ConsumerAvailableUrlPartInfo(urlPart)) : [],
        });
    }

    public clone(): ConsumerAvailable {
        const status: ConsumerAvailable = new ConsumerAvailable();

        status.organizationId = this.organizationId;
        status.consumerId = this.consumerId;
        status.isCanonical = this.isCanonical;
        status.urlParts = this.urlParts.map((urlPart) => urlPart.clone());

        return status;
    }
}